/* RESPONSIBLE TEAM: team-help-desk-experience */
import Controller from '@ember/controller';

export default class WorkspaceInboxInboxController extends Controller {
  queryParams = ['custom_folder_id'];
}
